import { IconButton, TextField } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import _ from 'lodash';
import { DateRangePicker } from "materialui-daterange-picker";
import React, { useState } from 'react';
import * as util from './DateUtil';

export default function DateRangeColumnFilter({ column: { filterValue, preFilteredRows, setFilter, Header, parent }, }) {
    const [value, setValue] = useState(filterValue || '');
    const [open, setOpen] = useState(false);
    // const [dateRange, setDateRange] = useState({});

    const toggle = () => setOpen(!open);

    const handleChange = (range) => {
        console.log(range);
        if (range) {
            setValue(range || undefined);
            setFilter(range || undefined);
        } else {
            setValue({});
            setFilter('');
        }
        setOpen(false);
    }

    const handleClearIcon = () => {
        handleChange(null);
    }

    const isShrink = (v) => {
        if (v) {
            return true;
        } else {
            return false;
        }
    }

    const getHeader = () => {
        if (parent && typeof (parent.Header) === 'string') {
            return parent.Header + " " + Header;
        } else {
            return Header;
        }
    }

    const getClearButton = () => {
        if (value) {
            return (
                <IconButton onClick={() => handleClearIcon(null)}>
                    <ClearIcon />
                </IconButton>
            )
        } else {
            return <></>;
        }
    }

    const getValue = () => {
        if (value) {
            console.log(value);
            let f = new Intl.DateTimeFormat('hu');
            let start = f.format(value.startDate);
            let end = f.format(value.endDate);
            return start + ' - ' + end;
        } else {
            return '';
        }
    }

    React.useEffect(() => {
        // console.log(filterValue)
        if (filterValue) {
            setValue(filterValue);
        } else {
            setValue('');
        }
    }, [filterValue]);

    React.useEffect(() => {
        // console.log(value)
        if (_.isEmpty(value)) {
            // console.log('empty');
            setOpen(false);
        }
    }, [value]);

    return (
        <>
            <TextField
                className="date-range-column-filter"
                variant='outlined'
                size='small'
                value={getValue()}
                // onChange={handleChange}
                InputProps={{
                    endAdornment: getClearButton(),
                    className: "text-column-filter-input",
                }}
                InputLabelProps={{ shrink: isShrink(value), style: { fontSize: 12, top: '2px' } }}
                label={getHeader()}
                onClick={toggle}
            />
            <DateRangePicker
                open={open}
                toggle={toggle}
                value={value}
                onChange={(range) => handleChange(range)}
                wrapperClassName="date-range-picker"
                definedRanges={util.definedRanges}
            />
        </>
    )
}



export function DateRangeColumnFilterFn(rows, id, filterValue) {
    if (filterValue) {
        return rows.filter(r => {
            const value = new Date(r.values[id]);
            const start = new Date(filterValue.startDate);
            const end = new Date(filterValue.endDate).setHours(23);
            return start < value && value < end;
        });
    } else {
        return rows;
    }
}